import Box from "ds/components/Box";
import TreeList from "ds/components/TreeList";

import { CommitTreeNode } from "./helpers";
import styles from "./styles.module.css";

type SpaceliftVcsRepoCommitFileTreeProps = {
  treeNodes: CommitTreeNode[];
  selectedFilePath?: string;
  onChange: (filePath: string) => void;
};

const SpaceliftVcsRepoCommitFileTree = ({
  treeNodes,
  selectedFilePath,
  onChange,
}: SpaceliftVcsRepoCommitFileTreeProps) => {
  return (
    <Box className={styles.fileTreePanel} direction="column" padding="x-large">
      <TreeList
        ariaLabel="Changed files"
        data={treeNodes}
        idKey="id"
        parentKey="parentId"
        nameKey="name"
        selectedKey={selectedFilePath}
        onChange={onChange}
      />
    </Box>
  );
};

export default SpaceliftVcsRepoCommitFileTree;
